import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks'
import { getSchedulingEligibility } from '../api'

export function useCheckSchedulingEligibilityOnMount(authenticated: boolean) {
  const appDispatch = useAppDispatch()

  const [loading, setLoading] = useState(authenticated)

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setLoading(true)
        await appDispatch(getSchedulingEligibility())
      } catch {
      } finally {
        if (mounted) {
          setLoading(false)
        }
      }
    }
    authenticated && execute()

    return () => {
      mounted = false
    }
  }, [appDispatch, authenticated])

  return loading
}
